import { SAVE_USER_SETTINGS, GET_CUSTOMER_SUBSCRIPTION } from "adapters/ehr.service";
import { store } from "../../redux/store";
import { EMPTY_PAYLOAD, LIMITS } from "./license_helper";
import { getFhirBasicSkeleton } from "./payload_helper";
import _ from "lodash";
import { activeStatus, getCurrentPlan, getPlanStatus, getProTrialStatus } from "screens/store/storeHelper";
import { set_current_subscription } from "redux/actions/SubscriptionAction";
import { setLicense, setPlanStatus } from "redux/actions/LicenseAction";

export const isFeatureAvailable = (action) => {
  const freeTrial = store?.getState()?.license?.package?.license === "TRIAL";
  const licenseObj = store?.getState()?.license?.package;
  const planStatus = store?.getState()?.license?.plan_status;
  if (freeTrial) {
    if (getProTrialStatus().isTrialExpired) {
      return false;
    }
  } else if (!planStatus || activeStatus.indexOf(planStatus) == -1) {
    return false;
  }
  const license = licenseObj?.license;

  if (!license) {
    console.error("No License Found in Redux");
    throw new Error("No License Found in Redux");
  }

  const featureLimitNumber = LIMITS?.[license]?.[action];

  if (featureLimitNumber === Infinity) return true;

  if (getNumberOfActionsDone(action) >= featureLimitNumber) return false;

  return true;
};

const getNumberOfActionsDone = (resource) => {
  const numberOfTimesResourceIsUsed =
    store?.getState()?.license?.package?.payload;
  return numberOfTimesResourceIsUsed?.[resource];
};

export const updateLicense = async (module, incrementValue = 1) => {
  const auth = store?.getState()?.auth;
  const licenseObj1 = store?.getState()?.license?.package;
  const licenseObj = _.cloneDeep(licenseObj1);

  const tempLicensePayloadForFhirBasic = {
    payload: licenseObj?.payload,
    license: licenseObj?.license,
    resetCount:licenseObj?.resetCount || 0
  };
  tempLicensePayloadForFhirBasic.payload[module] += incrementValue;
  let payload = getFhirBasicSkeleton();
  payload.subject.reference = `Person/${auth?.personData?.id}`;
  payload.extension[0].valueString = JSON.stringify(
    tempLicensePayloadForFhirBasic
  );
  payload.id = licenseObj?.id;

  const response = await SAVE_USER_SETTINGS("PUT", payload);

  try {
    return {
      ...JSON.parse(response?.data?.extension?.[0]?.valueString),
      id: response?.data?.id,
    };
  } catch (e) {
    console.log(e);
  }
};

export const upgradeLicense = (licenseObj = { license: "", id: "" }) => {
  const auth = store?.getState()?.auth;
  const tempLicensePayloadForFhirBasic = {
    payload: EMPTY_PAYLOAD,
    license: licenseObj.license,
    resetCount:0
  };
  let payload = getFhirBasicSkeleton();
  payload.subject.reference = `Person/${auth?.personData?.id}`;
  payload.extension[0].valueString = JSON.stringify(
    tempLicensePayloadForFhirBasic
  );
  payload.id = licenseObj?.id;
  return SAVE_USER_SETTINGS("PUT", payload).then((response) => {
    try {
      const payload = {
        ...JSON.parse(response?.data?.extension?.[0]?.valueString),
        id: response?.data?.id,
      };
      return payload;
    } catch (error) {
      console.log(error);
    }
  });
};

export const parseLicenseFromSetting = (licenseSetting) => {
  try {
    const resource = licenseSetting?.data?.entry?.[0]?.resource;
    return {
      ...JSON.parse(resource?.extension?.[0]?.valueString),
      id: resource?.id,
    };
  } catch (error) {
    console.error("Error Parsing license JSON", error);
    return null;
  }
};

export const fetchAndUpdateSubscription = async (dispatch) => {
  try {
    const response = await GET_CUSTOMER_SUBSCRIPTION();
    
    if (!response) {
      return { success: false, subscriptions: null, error: new Error("No response from server") };
    }
    
    dispatch(set_current_subscription(response));
    
    if (response?.subscriptions && response.subscriptions.length > 0) {
      const currentLicense = store?.getState()?.license;
      const newPlan = getCurrentPlan();
      const newStatus = getPlanStatus(response?.subscriptions);
      
      if (newPlan !== currentLicense?.package?.license) {
        const licenseResponse = await upgradeLicense({
          license: newPlan?.toUpperCase(),
          id: currentLicense?.package?.id,
        });
        
        if (licenseResponse) {
          dispatch(setLicense(licenseResponse));
        }
      }

      if(newStatus) {
        dispatch(setPlanStatus(newStatus));
      }
      
      return { 
        success: true, 
        subscriptions: response.subscriptions, 
        error: null 
      };
    }
    
    return { 
      success: false, 
      subscriptions: null, 
      error: new Error("No subscriptions found") 
    };
  } catch (error) {
    console.error("Error fetching subscription:", error);
    return { 
      success: false, 
      subscriptions: null, 
      error 
    };
  }
};

export const getPlanDetailsLabel = (i18n) => {
  const plan = getCurrentPlan().toLowerCase();
  switch (plan) {
    case "trial":
      return i18n.t("dashboard2.TRIAL_PLAN_PARTICULARS");
    case "lite":
      return i18n.t("dashboard2.LITE_PLAN_PARTICULARS");
    case "advanced":
      return i18n.t("dashboard2.ADVANCED_PLAN_PARTICULARS");
    case "pro":
      return i18n.t("dashboard2.PRO_PLAN_PARTICULARS");
    default:
      return `${i18n.t(`store.${_.capitalize(getCurrentPlan())}`)} ${i18n.t(
        "dashboard2.PLAN_PARTICULARS"
      )}`;
  }
};
